import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { EmailHtmlNormalizerService } from 'src/app/services/email-html-normalizer.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,

 
})
export class TextEditorComponent implements OnInit,OnDestroy  {

  sanitizedUrl: string = '';


  url = '';

  group:UntypedFormGroup;
  data: any;
  field: any;
  _form: any;
  trustedHtmlContent: SafeHtml;
  constructor(
    private dialogRef: MatDialogRef<TextEditorComponent>,
    @Inject(MAT_DIALOG_DATA) data,
   private sanitizer: DomSanitizer,
    private formBuilder: UntypedFormBuilder,
  private emailHtmlNormalizer: EmailHtmlNormalizerService, private router: Router

  ) {
    this.data = data;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
   

  }


  createForm() {
    this._form = this.formBuilder.group({
      value: ''
   
    });
  }

//  editorConfig:AngularEditorConfig = {
//     editable: true,
//     spellcheck: true,
//     height: '15rem',
//     minHeight: '5rem',
//     placeholder: 'Enter text here...',
//     translate: 'no',
//     defaultParagraphSeparator: 'p',
//     defaultFontName: 'Arial',
//     sanitize: false,
//     toolbarHiddenButtons: [
//       ['bold']
//     ]
//   };
  ngOnInit() {
    this.createForm();

    // NOTE: ngx-editor removed from this dialog; using <calsoft-doc-editor> bound to _form.controls.value
   
    if (this.data != null) {
      // Patch initial HTML into the CVA-bound control.
      this._form.patchValue({ value: this.data });
      this.trustedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this._form.get('value')?.value);
    }
   
  }


  ngOnDestroy(): void {
    // calsoft-doc-editor manages its own teardown
      this._onDestroy.next();
      this._onDestroy.complete();
  }

  confirm(i, j) {
    let html = (this._form.value.value || '').toString();
    try {
      html = this.emailHtmlNormalizer.normalizeHtmlForEmail(html);
    } catch (e) {
      // ignore
    }
    this.dialogRef.close({ event: 'add', data: html });
  }

  close(i) {
    let html = (this._form.value.value || '').toString();
    try {
      html = this.emailHtmlNormalizer.normalizeHtmlForEmail(html);
    } catch (e) {
      // ignore
    }
    this.dialogRef.close({ event: 'close', data: html });
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();
}
